import type { LiquidityStrategyDepositToken } from '@ui/utils/strategy';
import { resetWhenRouterChange } from '@ui/utils/zustandMiddleware';
import { create } from 'zustand';

export type UseStrategyFlowDrawerStore = {
  isOpen: boolean;
  isWithdraw: boolean;
  token: LiquidityStrategyDepositToken;
  onOpen: (options: {
    isWithdraw: boolean;
    token: LiquidityStrategyDepositToken;
  }) => void;
  onClose: () => void;
};

export const useStrategyFlowDrawer = create(
  resetWhenRouterChange<UseStrategyFlowDrawerStore>((set) => ({
    isOpen: false,
    isWithdraw: false,
    token: 'cro',
    onOpen: ({ isWithdraw, token }) => {
      set({
        isOpen: true,
        isWithdraw,
        token,
      });
    },
    onClose: () => {
      useStrategyFlowDrawer.getState().$$resetData?.();
    },
  })),
);
